import { CotationsApi } from '@/api/cotations';
import StoreBuilder from '../store-builder';

const builder = new StoreBuilder('cotations');
builder.setLoaders({
  historique: { loadFunction: ({ idArticle }:{ idArticle: number }) => CotationsApi.getHistoriqueCotations(idArticle), cacheTime: 300 }
});

const module = builder.build();
export default module;
